import { Condition } from '@shared/models/rules-engine';

export enum ProcFeeMappingStatus {
  NewMappingRequired = 1,
  ActiveMapping = 2,
  NoMappingRequired = 3,
}

export interface ProcFeeMappingViewModel {
  lenderNameId?: number;
  order: number;
  productFamily: string;
  procFeeProductId: number;
  paymentRouteId: number;
  status: ProcFeeMappingStatus;
  ruleId: number | null;
  condition: Condition | null;
  conditionDisplayView: string;
  comment: string | null;
  lastUpdatedBy: string;
  validationMessage: string | null;
}

export interface LenderProcFeeMappings {
  lenderName: string;
  lastUpdateDate: Date | null;
  mappings: ProcFeeMappingViewModel[];
}

export interface ProcFeeMappingRuleRequestModel {
  ruleId: number | null;
  lenderNameId: number;
  paymentRouteId: number;
  procFeeProductId: number;
  condition: Condition | null;
  comment: string;
  order: number;
  productFamily: string;
  status: ProcFeeMappingStatus;
}

export enum ProcFeeMappingPreviewResultProductScenarioStatus {
  Matched = 1,
  NotMatched = 2,
  ScenarioNotPossible = 3,
}

interface ProcFeeMappingPreviewResultProductScenario {
  scenarioIndex: number;
  status: ProcFeeMappingPreviewResultProductScenarioStatus;
  matchedProcFeeFamilyId: number | null;
  matchedProcFeeFamily: string | null;
  justification: string[] | null;
}

export interface ProcFeeMappingPreviewResultProduct {
  lendingType: string;
  productId: number;
  productCode: string;
  productDescription: string;
  scenarios: ProcFeeMappingPreviewResultProductScenario[];
}

export interface ProcFeeMappingPreviewResultScenario {
  label: string;
}

export interface ProcFeeMappingPreviewResult {
  foundLender: boolean;
  scenarios?: ProcFeeMappingPreviewResultScenario[];
  products?: ProcFeeMappingPreviewResultProduct[];
  warnings: string[];
}
